// Print options shared by the editors. Option ids are stored with orders, so they must never change.
export const FRAMES = [
    { id: 1, name: 'Fekete', labelKey: 'editor.frame.black', icon: 'frame-icon_1.png', preview: 'frame-black.webp', price: 2000 },
    { id: 2, name: 'Fehér', labelKey: 'editor.frame.white', icon: 'frame-icon_2.png', preview: 'frame-white.webp', price: 2000 },
];

export const SIZES = [
    { id: 1, name: '30*40cm', width: 30, height: 40 },
    { id: 2, name: '40*50cm', width: 40, height: 50, price: 4500 },
    { id: 3, name: '50*70cm', width: 50, height: 70, price: 5000 },
    { id: 4, name: '60*90cm', width: 60, height: 90, price: 6500 },
];

export const ORIENTATIONS = [
    { id: 1, name: 'Álló', labelKey: 'editor.orientation.portrait', preview: 'vertical-orientation-icon.svg' },
    { id: 2, name: 'Fekvő', labelKey: 'editor.orientation.landscape', preview: 'horizontal-orientatio-icon.svg' },
];

export const DIGITAL_PRICE = 500;

export const DEFAULT_TITLE_TYPO = {
    id: 1,
    label: 'Figtree Bold',
    scale: 'scale-[65%]',
    class: 'font-Figtree uppercase font-bold leading-[1.2]',
};

export const DEFAULT_MESSAGE_TYPO = {
    id: 2,
    label: 'Figtree Regular',
    scale: 'scale-[70%]',
    class: 'font-Figtree',
};

export const DEFAULT_MESSAGE_SIZE = 0.8;

// Poster and layered wooden version of each map product, for MapProductSwitch.
export const MAP_PRODUCTS = [
    { route: 'editors-map', name: 'Poszter', labelKey: 'editor.product.poster' },
    { route: 'editors-wood-map', name: 'Rétegelt fa térkép', labelKey: 'editor.wood_map.title' },
    { route: 'editors-topo-map', name: 'Domborzat', labelKey: 'editor.topo_map.title' },
    { route: 'editors-city-map', name: 'Városi épületek', labelKey: 'editor.city_map.title' },
];
export const STAR_MAP_PRODUCTS = [
    { route: 'editors-star-map', name: 'Poszter', labelKey: 'editor.product.poster' },
    { route: 'editors-wood-star-map', name: 'Rétegelt fa csillagtérkép', labelKey: 'editor.wood_star_map.title' },
];
